import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { COOKIE, getCookie } from "../../../services/cookie";
import constants from "../../../constants/constants";

function VideoHlsPlayer({ videoDetails, apiUrl }) {
    const videoRef = useRef(null);
    const hlsRef = useRef(null);
    const [subtitleUrl, setSubtitleUrl] = useState(null);
    useEffect(() => {
        if (!videoDetails?.filename) return;
        const video = videoRef.current;
        const src = `${apiUrl}/${videoDetails.filename}/index.m3u8`;
        if (Hls.isSupported()) {
            const hls = new Hls({
                xhrSetup: (xhr) => {
                    xhr.setRequestHeader(
                        "Authorization",
                        `Bearer ${getCookie(COOKIE.Token)}`
                    );
                },
            });
            hls.loadSource(src);
            hls.attachMedia(video);
            hlsRef.current = hls;
            return () => {
                hls.destroy();
            };
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = src;
        }
    }, [videoDetails]);
    useEffect(() => {
        const video = videoRef.current;
        const handleEnded = () => {
            video.pause();
            video.currentTime = video.duration;
        };
        video.addEventListener("ended", handleEnded);
        return () => {
            video.removeEventListener("ended", handleEnded);
        };
    }, []);

    useEffect(() => {
        const loadSubtitle = async () => {
            if (!videoDetails?.filename) return;
            const response = await fetch(
                `${constants.ApiUrl}/get-video-caption/${getCookie(COOKIE.UserId)}/${videoDetails.videoId}/${videoDetails.filename}/subtitle.vtt`,
                {
                    headers: {
                        Authorization: `Bearer ${getCookie(COOKIE.Token)}`
                    }
                }
            );
            const blob = await response.blob();
            if(blob.type !== "text/vtt") {
                return;
            }
            setSubtitleUrl(URL.createObjectURL(blob));
        };

        loadSubtitle();
    }, [videoDetails]);

    return (
        <video
            ref={videoRef}
            controls
            autoPlay
            playsInline
            className="w-full md:max-h-[70vh]"
            controlsList="nodownload"
            onContextMenu={(e) => e.preventDefault()}
        >
            {
                subtitleUrl !== null && (
                    <track
                        kind="subtitles"
                        src={subtitleUrl}
                        srcLang="en"
                        label="English"
                    />
                )
            }
        </video>
    );
}

export default VideoHlsPlayer;
